export default __webpack_public_path__ + "static/media/lineStickr01TC.05ebfc7a.jpg";